import React, { useState, useEffect } from 'react';
import { PaymentMethod, BankAccount, CreatePaymentMethodRequest, UpdatePaymentMethodRequest } from '../types';

interface PaymentMethodFormProps {
    paymentMethod?: PaymentMethod | null;
    bankAccounts: BankAccount[];
    onSubmit: (data: CreatePaymentMethodRequest | UpdatePaymentMethodRequest) => void;
    onCancel: () => void;
}

const PaymentMethodForm: React.FC<PaymentMethodFormProps> = ({
    paymentMethod,
    bankAccounts,
    onSubmit,
    onCancel
}) => {
    const [formData, setFormData] = useState({
        description: '',
        bankAccountId: '',
        isForPayment: true,
        isForPayout: true
    });

    useEffect(() => {
        if (paymentMethod) {
            setFormData({
                description: paymentMethod.description,
                bankAccountId: paymentMethod.bankAccountId,
                isForPayment: paymentMethod.isForPayment,
                isForPayout: paymentMethod.isForPayout
            });
        }
    }, [paymentMethod]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSubmit(formData);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
        }));
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <label htmlFor="description" className="block text-sm font-medium text-secondary-700 mb-1">
                    Descrição *
                </label>
                <input
                    type="text"
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    required
                    className="input-field"
                    placeholder="Digite a descrição do método"
                />
            </div>

            <div>
                <label htmlFor="bankAccountId" className="block text-sm font-medium text-secondary-700 mb-1">
                    Conta Bancária *
                </label>
                <select
                    id="bankAccountId"
                    name="bankAccountId"
                    value={formData.bankAccountId}
                    onChange={handleChange}
                    required
                    className="input-field"
                >
                    <option value="">Selecione uma conta bancária</option>
                    {bankAccounts.map(account => (
                        <option key={account.id} value={account.id}>
                            {account.name}
                        </option>
                    ))}
                </select>
            </div>

            <div className="space-y-3">
                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="isForPayment"
                        name="isForPayment"
                        checked={formData.isForPayment}
                        onChange={handleChange}
                        className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-secondary-300 rounded"
                    />
                    <label htmlFor="isForPayment" className="ml-2 block text-sm text-secondary-700">
                        Usar para pagamentos
                    </label>
                </div>

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="isForPayout"
                        name="isForPayout"
                        checked={formData.isForPayout}
                        onChange={handleChange}
                        className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-secondary-300 rounded"
                    />
                    <label htmlFor="isForPayout" className="ml-2 block text-sm text-secondary-700">
                        Usar para recebimentos
                    </label>
                </div>
            </div>

            <div className="flex justify-end space-x-3 pt-4">
                <button
                    type="button"
                    onClick={onCancel}
                    className="btn-secondary"
                >
                    Cancelar
                </button>
                <button
                    type="submit"
                    className="btn-primary"
                >
                    {paymentMethod ? 'Atualizar' : 'Criar'}
                </button>
            </div>
        </form>
    );
};

export default PaymentMethodForm;








